import { render, staticRenderFns } from "./baseStation.vue?vue&type=template&id=675f36d7&scoped=true&"
import script from "./baseStation.vue?vue&type=script&lang=js&"
export * from "./baseStation.vue?vue&type=script&lang=js&"
import style0 from "./baseStation.vue?vue&type=style&index=0&id=675f36d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675f36d7",
  null
  
)

export default component.exports